import { motion } from "framer-motion";
import { Brain, AlertTriangle, Lock } from "lucide-react";

const features = [
  {
    icon: Brain,
    title: "Learns your mappings",
    description:
      "Genie remembers vendor-ledger choices per client and improves with every correction. No more asking you again and again!",
  },
  {
    icon: AlertTriangle,
    title: "Catches drift, flags exceptions",
    description:
      "Even when descriptions/formats change, Genie still picks right ledgers and flags low‑confidence cases for review.",
  },
  {
    icon: Lock,
    title: "Maker–checker by design",
    description:
      "Nothing hits Tally without approval. Every entry has an audit trail and exportable Excel logs.",
  },
];

const ControlLearning = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container-narrow mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-4">
            The assistant that learns and never posts without you
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
                <feature.icon className="w-8 h-8 text-primary" />
              </div>
              <h3 className="font-display text-xl font-semibold text-foreground mb-3">
                {feature.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ControlLearning;
